import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import OfficeBuildingIcon from '@atlaskit/icon/core/office-building';
import { Anchor, Box, Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { useRoutes } from '@/common/hooks';
import { FASTSHIFT_PATH_KEYS, FASTSHIFT_PATHS } from '@/common/routes/constants';

const styles = cssMap({
	card: {
		borderRadius: token('radius.large'),
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border'),
		textDecoration: 'none',
		backgroundColor: token('elevation.surface.overlay'),
		padding: token('space.250'),
		cursor: 'pointer',
		textAlign: 'start',

		'&:hover': {
			backgroundColor: token('elevation.surface.overlay.hovered'),
		},
	},
	iconFrame: {
		alignItems: 'center',
		backgroundColor: token('color.background.neutral'),
		borderRadius: token('radius.small'),
		display: 'flex',
		flexShrink: 0,
		height: '32px',
		justifyContent: 'center',
		width: '32px',
	},
});

export interface OrganizationCardProps {
	organizationId: string;
	organizationName: string;
	onClick: () => void;
}

export const OrganizationCard = ({
	organizationId,
	organizationName,
	onClick,
}: OrganizationCardProps) => {
	const { getPathByOrganizationId } = useRoutes();
	const orgDetailsPath = getPathByOrganizationId(
		FASTSHIFT_PATHS[FASTSHIFT_PATH_KEYS.ORGANIZATION_DETAILS],
		organizationId,
	);

	return (
		<Anchor
			href={orgDetailsPath}
			xcss={styles.card}
			testId={`organization-card-${organizationId}`}
			onClick={onClick}
		>
			<Inline space="space.150" alignBlock="center">
				<Box xcss={styles.iconFrame}>
					<OfficeBuildingIcon label="" color="currentColor" />
				</Box>
				<Heading size="small" as="h3">
					{organizationName}
				</Heading>
			</Inline>
		</Anchor>
	);
};
